module.exports = __webpack_public_path__ + "static/media/ihre-ansprechpartner.01132813.jpg";